
const CertificadoGarantia = () => {

  return (
    <div className="container my-3 my-md-5">
      <div className="row">
        <div className="col-12 col-md-6 offset-md-3">
          <h2>CERTIFICADO DE GARANTÍA</h2>
          <p className="mt-3">Sr/sra cliente, usted acaba de adquirir un equipo o celular <strong>CELUBA</strong>. Nos encontramos en <strong>Drago 72</strong> o <strong>Chiclana 130</strong>. Nuestro número de WhatsApp de Drago es <strong>2916435709</strong> y el de Chiclana <strong>2914629352</strong>, de la ciudad de <strong>Bahía Blanca</strong>, Provincia de Buenos Aires.</p>

          <p>Este certificado de garantía ampara el producto electrónico descrito a continuación, adquirido por el cliente bajo las condiciones especificadas en este documento.</p>

          <h5 className="mt-4">Datos del Producto:</h5>
          <ul>
            <li><strong>Nombre del producto:</strong> [Nombre del producto]</li>
            <li><strong>Modelo:</strong> [Modelo]</li>
            <li><strong>Número de serie:</strong> [Número de serie]</li>
            <li><strong>Fecha de compra:</strong> [Fecha de compra]</li>
            <li><strong>Nombre del comprador:</strong> [Nombre del comprador]</li>
          </ul>

          <h5 className="mt-4">Condiciones de Garantía:</h5>
          <ol>
            <li>La presente garantía cubre defectos de fabricación y funcionamiento del producto por un período de <strong>6 meses</strong> a partir de la fecha de compra, sin excepción.</li>
            <li>Durante el período de garantía, Celuba se compromete a darle una solución inmediata o reemplazar el producto sin costo adicional para el cliente, siempre que el defecto sea de origen y no consecuencia de un mal uso.</li>
            <li>La garantía perderá validez en los siguientes casos:
              <ul>
                <li>Uso indebido, negligencia o daños causados por golpes, caídas, líquidos, o intervención de terceros no autorizados.</li>
                <li>Manipulación o alteración del producto o sus componentes.</li>
                <li>Uso de accesorios no originales o incompatibles.</li>
                <li>Factores externos como fluctuaciones eléctricas, descargas eléctricas o desastres naturales.</li>
              </ul>
            </li>
            <li>Para hacer válida la garantía, el cliente deberá presentar este certificado junto con la factura o comprobante de compra.</li>
          </ol>

          <h5 className="mt-4">Proceso de Reclamación:</h5>
          <ul>
            <li>En caso de falla, el cliente debe comunicarse con nuestras sucursales llamando al <strong>2916435709</strong> o <strong>2914629352</strong>.</li>
            <li>Nuestro equipo evaluará el problema y proporcionará instrucciones sobre el procedimiento a seguir.</li>
          </ul>

          <p className="mt-4"><strong>Nota:</strong> Este certificado es intransferible y únicamente válido para el comprador original del producto.</p>

          <p className="mt-4 mb-0">Atentamente,<br /><strong>Celuba</strong></p>
        </div>
      </div>
    </div>
  )

}

export default CertificadoGarantia;